import * as React from 'react';


const useToken = (t) => {

    if (t) {
        localStorage.setItem('token', JSON.stringify(t));
    }

    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        const userToken = JSON.parse(tokenString);
        return userToken
    } 

    const [token, setToken] = React.useState(t ?? getToken())

    const saveToken = userToken => {

        if (userToken)
            localStorage.setItem('token', JSON.stringify(userToken));
        else
            localStorage.removeItem('token');
        
        setToken(userToken);
    }   

    return {
        setToken: saveToken,
        token
    }
    
}

export default useToken;